<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="15" />
            <div class="box5" style="position: relative;min-height: 900px;">
                <div style="overflow: hidden;">
                    <div class="box6" style="float: left;">开票记录</div>
                    <div style="float: right;">
                        <a-input-search placeholder="输入订单编号/商品货号/名称查询 " enter-button="查询" size="large" @search="onSearch" style="width:360px" />
                    </div>
                </div>
                <div style="width: 100%;height: 1px;background: #EDE9E9; margin: 20px 0"></div>

                <div class="box12">
                    <div class="box13">订单编号</div>
                    <div class="box13">订单实付金额</div>
                    <div class="box13">购买用户</div>
                    <div class="box13">订单时间</div>
                    <div class="box13">发票号码</div>
                    <div class="box13">开票时间</div>
                    <div class="box13" style="color: #666666;">操作</div>
                </div>

                <div>
                    <div :key="index" v-for="(item, index) in list" class="box12" style="margin-top: 0; background: none; border-bottom: 1px solid #EEEEEE;">
                        <div class="box13">{{ item.orderSn }}</div>
                        <div class="box13">{{ item.orderAmount | moneyStr }}</div>
                        <div class="box13">{{ item.userRealName }}</div>
                        <div class="box13">{{ item.createdAt }}</div>
                        <div class="box13">{{ item.invoiceNumber }}</div>
                        <div class="box13">{{ item.finishedAt }}</div>
                        <router-link :to="'/invoice_details?uuid=' + item.orderId"><div class="box13" style="color: #2B9A34;cursor: pointer;">查看</div></router-link>
                    </div>
                </div>

                <div v-if="list.length == 0" style="text-align: center; font-size: 14px; margin-top: 40px;">
                    没有数据~
                </div>

                <div style="position: absolute; bottom: 2%; width: 100%;display: flex;justify-content: center;align-items: center;">
                    <a-pagination show-quick-jumper :default-current="1" :total="totalPages * 10" @change="fenye_onChange" />
                </div>
                <div style="width: 100%; height: 100px;"></div>
            </div>
        </div>

        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            totalPages: 1, //总页数
            list: [], //我的开票记录
            search: '',
            page: 0
        };
    },
    filters: {
        moneyStr(value) {
            value = value ? value / 100 : 0;
            return '￥' + value.toFixed(2);
        }
    },
    methods: {
        // 搜索
        onSearch(e) {
            this.search = e;
            this.get_my_invoice_myPage();
        },
        // 翻页
        fenye_onChange(e) {
            this.page = e - 1;
            this.get_my_invoice_myPage();
        },
        // 获取开票记录
        get_my_invoice_myPage() {
            this.api
                .get_my_invoice_myPage({
                    page: this.page,
                    search: this.search
                })
                .then(res => {
                    if (res.ok) {
                        this.list = res.data.content;
                        this.totalPages = res.data.totalPages;
                    } else {
                        that.$message.error(res.message);
                    }
                });
        }
    },
    created() {
        this.get_my_invoice_myPage();
    }
};
</script>

<style scoped>
.biaoti {
    font-size: 22px;
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.shijian {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-top: 20px;
}

.zhengwen {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-top: 40px;
}

.xuanzhong {
    border: 1px solid #2b9a34;
}

.goods_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}

.goods_title1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
}

.title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.box5 {
    min-height: 1023px;
    width: 80%;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.type_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
    margin-left: 20px;
}

.type_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999;
    margin-top: 10px;
    margin-left: 20px;
}

.rich_text_box {
    width: 90%;
    float: left;
    margin-top: 25px;
    margin-left: 2%;
    height: 400px;
    overflow: hidden;
}

.tijiao {
    width: 100px;
    height: 40px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    margin-left: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
    cursor: pointer;
}
.box13 {
    width: 14.28%;
    height: 100%;
    float: left;

    font-size: 12.73px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
    text-align: center;

    white-space: nowrap; /* 规定文本是否折行 */
    overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
    text-overflow: ellipsis;
}
.box12 {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #f4f4f4;
    margin-top: 4%;
}
</style>



// WEBPACK FOOTER //
// src/components/billing_record.vue